import jQuery from "jquery";
import Popper from "popper.js";
import * as VueGoogleMaps from 'vue2-google-maps';
import slick from "slick-carousel";

// Bootstrap does not use the modules correctly - we need to make them available in window scope for bootstrap.
window.jQuery = jQuery;
window.$ = jQuery;
window.Popper = Popper;
const bootstrap = require('bootstrap');

import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue);
import AsyncComputed from 'vue-async-computed'
Vue.use(AsyncComputed);
import VueResource from 'vue-resource'
Vue.use(VueResource);

Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyD44NLQl8fivCvVh6qv3pYej_xqAoQyj7o',
    }
});
import EmailForm from './components/EmailForm.vue'
import NewsContainer from './components/NewsContainer.vue'
import FAQContainer from './components/FAQContainer.vue'
import Licensetool from './components/licensetool/Licensetool.vue'
import SupportForm from './components/SupportForm.vue'
import SecureUpload from './components/SecureUpload.vue'
import RiskopInstallation from './components/RiskopInstallation.vue'
import RiskopUpdate from './components/RiskopUpdate.vue'
import ApproachContainer from './components/ApproachContainer.vue'
import '../scss/app.scss';

const checkScroll = (threshold) => {
    window.addEventListener('scroll', function (e) {
        if (window.scrollY >= threshold) {
            document.getElementById("header")?.classList.add("header-outer--scrolled");
            document.getElementById("animationLB")?.classList.add("animation--scrolled");
            document.getElementById("animationLBsmall")?.classList.add("animation--scrolled");
            document.getElementById("animationRT")?.classList.add("animation--scrolled");
            document.getElementById("scroll-indicator")?.classList.add("indicator--scrolled");
        } else {
            document.getElementById("header")?.classList.remove("header-outer--scrolled");
            document.getElementById("animationLB")?.classList.remove("animation--scrolled");
            document.getElementById("animationLBsmall")?.classList.remove("animation--scrolled");
            document.getElementById("animationRT")?.classList.remove("animation--scrolled");
            document.getElementById("scroll-indicator")?.classList.remove("indicator--scrolled");
        }
    }, false);
};

$("#supportform").on("submit", event => {
    let data = $("#supportform").serialize();
    $.ajax({
        type: "POST",
        url: $("#supportform").attr("data-api-url"),
        data: data,
        success: response => {
            $("#supportform").addClass("d-none")
            $("#supportform-success").text(response.message).removeClass("d-none")[0].scrollIntoView();
        }
    });
    return false;
})

function registerDynamic(id, vueComponent) {
    let element = document.getElementById(id);
    if (element) {
        let props = {};
        for (let i = 0; i < element.attributes.length; i++) {
            if (element.attributes[i].nodeName.startsWith("data-")) {
                props[element.attributes[i].nodeName.substr(5)] = element.attributes[i].value;
            }
        }
        new Vue({
            el: element,
            render: (h) => h(vueComponent, {
                props
            }),
        });
    }
}


$(document).ready(() => {
    // show random claim on every page load
    const claims = [
        {
            text: "So<br/>sehen <span>echte</span><br>Software-<br/>entwickler aus*",
            image: "/images/redesign/hacker.png",
            legend: "<p><mark>* Was einen echten Software-Entwickler ausmacht,</mark> entscheidet bei uns nicht die Wahl des Hoodies, sondern die Leidenschaft beim Programmieren.</p>"
        },
        {
            text: "Software-<br>entwicklung<br><span>ist</span> Raketen-<br/>wissenschaft*",
            image: "/images/redesign/rocketscience1.png",
            legend: "<p><mark>* Deshalb haben wir erfahrene Experten</mark>, die Ihnen bei der Umsetzung Ihrer IT Projekte helfen. :-)</p>"
        },
        {
            text: "Software-<br>entwickler<br>sitzen bis <span>nachts</span><br/>am Rechner*",
            image: "/images/redesign/programmer.png",
            legend: "<p><mark>* Bei uns geht es darum, Probleme unserer Kunden zu verstehen</mark> und innovative Lösungsansätze zu entwickeln.<br/>Egal, zu welcher Uhrzeit - das gilt natürlich nicht für Support-Mitarbeiter :-)</p>"
        },
        {
            text: "Behandeln<br>Sie Ihre <span>Pass-<br>wörter</span> wie Ihre<br>Unterwäsche*",
            image: "/images/redesign/boxer.jpg",
            legend: "<p><mark>* Nicht teilen, regelmäßig wechseln und runter damit vom Schreibtisch</mark> :-)<br/>Wir bei fumiX nehmen IT-Sicherheit sehr ernst!</p>"
        },
        {
            text: "Software-<br>entwicklung<br>ist <span>Kunst</span>*",
            image: "/images/redesign/art6.png",
            legend: "<p><mark>* Softwareentwickler bei fumiX sind kreative Künstler und Problemlöser</mark>, die auch mal &ldquo;out of the box&rdquo; denken.</p>"
        },
        {
            text: "Spaghetti<br>mit Sardinen,<br>Schokolade<br>und Sauerkraut<br/>dank <span>KI</span>?*",
            image: "/images/redesign/spaghetti2.png",
            legend: "<p><mark>* Nicht Ihr Ding? - Wir bei fumiX helfen Ihnen, Künstliche Intelligenz gezielt</mark><br>und sinnstiftend in Ihrem Unternehmen einzusetzen.</p>"
        }, {
            text: "Commit-<br/>Nachrichten<br/>sind wie<br/><span>Tagebuch-<br/>einträge</span>*",
            image: "/images/redesign/art7.png",
            legend: "<p><mark>* Ehrlich, regelmäßig und besser nicht im Affekt geschrieben.</mark><br/>Wir bei fumiX haben langjährige Erfahrung in der Entwicklung von Software und wissen wie wichtig gute Dokumentation für die Zusammenarbeit ist.</p>"
        }
    ];
    const claimIndex = Math.floor(Math.random() * claims.length);
    const basePath = $("#claimimage").data("path")

    $("#claimtext").html(claims[claimIndex].text);
    $("#legend").html(claims[claimIndex].legend);
    $("#claimimage").attr("src", basePath + claims[claimIndex].image);


    // We need this to reload the animated GIFs on every page load
    const rId = Math.random().toString(36).slice(2, 9);
    const imgpathLB = $("body").data("path") + "/" + require(`../webapp/images/redesign/anim-edge-transparent.gif`).default;
    const imgpathLBsmall = $("body").data("path") + "/" + require(`../webapp/images/redesign/anim-edge-transparent-small.gif`).default;

    // if ($("#animationLB").length) {
    //     $("#animationLB").css({ backgroundImage: `url(${imgpathLB}?random=${rId})` });
    // }
    if ($("#animationRT").length) {
        $("#animationRT").css({ backgroundImage: `url(${imgpathLB}?random=${rId})` });
    }
    if ($("#animationLBsmall").length) {
        $("#animationLBsmall").css({ backgroundImage: `url(${imgpathLBsmall}?random=${rId})` });
    }

    function sleep(milliseconds) {
        return new Promise(function (resolve) { setTimeout(resolve, milliseconds) });
    }

    function registerTooltips(element) {
        $(element).find('[data-toggle="tooltip"]').tooltip()
    }
    Vue.mixin({
        mounted: function () {
            registerTooltips(this.$el);
        },
        updated: function () {
            registerTooltips(this.$el);
        }
    })
    registerDynamic("secure-upload", SecureUpload);
    registerDynamic("supportform", SupportForm);
    registerDynamic("emailform", EmailForm);
    registerDynamic("news-container", NewsContainer);
    registerDynamic("licensetool", Licensetool);
    registerDynamic("faq-container", FAQContainer);
    registerDynamic("riskop-installation", RiskopInstallation);
    registerDynamic("riskop-update", RiskopUpdate);
    registerDynamic("approach-container", ApproachContainer);
    registerTooltips(document.body);

    document.body.setAttribute("data-has-good-js", "true");


    checkScroll(25);

    sleep(1500).then(() => {
        if (window.scrollY <= 15) {
            const el = document.getElementById("scroll-indicator");
            if (el) {
                el.classList.add("show");
            }
        }
    });

    $('.customer-logos').slick({
        centerMode: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 1000,
        arrows: false,
        dots: false,
        cssEase: 'ease-in-out',
        variableWidth: true,
        // variableHeight: true,
        mobileFirst: true,
        pauseOnHover: true,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 6
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 450,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });

    // $(".menu-parent").on("click", function () {
    //     $(".menu-parent").parent().removeClass("visible");
    //     $(this).parent().addClass("visible");
    // });

    // $(document).on("click", function (e) {
    //     if ($(e.target).closest(".menu-parent").length === 0) {
    //         $(".menu-parent").parent().removeClass("visible");
    //     }
    // });

    $(".toggle-btn").on("click", function (e) {
        const target = $(this).data("target");
        $(target).slideToggle("slow");
    });

});



